import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsFieldModel } from './widgets-field.model';

export class WidgetsRelatedinputModel extends WidgetsFieldModel {
  readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.ORDINAL_IN_SET;
  name: string = 'Related Input';
  readonly badge: string = 'O';
  type: string = 'relatedInput';
  isPasteEnabled: boolean = false;
  suffix?: string = '';
  prefix?: string = '';
  middlePrefix?: string = '';
  sequenceNumberKey?: string = '';
  totalNumberKey?: string = '';
  maxTextLength?: number;
  validInputs?: string[] = [];
  min?: number;
  max?: number;
  unrelatedFlag:boolean = false; 

  toJSON(): any { const extendedSpecificProperties = {
      prefix: this.prefix ? this.prefix : undefined,
      middlePrefix: this.middlePrefix ? this.middlePrefix : undefined,
      suffix: this.suffix ? this.suffix : undefined,
      isPasteEnabled: this.isPasteEnabled ? this.isPasteEnabled : undefined,
      unrelatedFlag: this.unrelatedFlag ? this.unrelatedFlag : undefined,
      sequenceNumberKey: this.sequenceNumberKey ? this.sequenceNumberKey : undefined,
      totalNumberKey: this.totalNumberKey ? this.totalNumberKey : undefined,
      maxTextLength: this.maxTextLength ? this.maxTextLength : undefined,
      validInputs: this.validInputs ? this.validInputs : undefined,
      min: this.min ? this.min : undefined,
      max: this.max ? this.max : undefined,
    };

    return { ...super.toJSON(), ...extendedSpecificProperties };
  }

  /**
   * Clone this node from an origin.
   *
   * @param origin
   * @returns the cloned node
   */
  cloneFrom(origin: WidgetsRelatedinputModel): WidgetsRelatedinputModel {
    // Clone base class
    super.cloneFrom(origin);

    if (origin.type) {
      this.type = origin.type;
    } else {
      this.type = 'relatedInput';
    }

    // Model specific
    if (origin.suffix) {
      this.suffix = origin.suffix;
    }
    if (origin.prefix) {
      this.prefix = origin.prefix;
    }
    if (origin.middlePrefix) {
      this.middlePrefix = origin.middlePrefix;
    }
    if (origin.suffix) {
      this.suffix = origin.suffix;
    }
    if (origin.isPasteEnabled) {
      this.isPasteEnabled = origin.isPasteEnabled;
    }
    if (origin.unrelatedFlag) {
      this.unrelatedFlag = origin.unrelatedFlag;
    }
    if (origin.sequenceNumberKey) {
      this.sequenceNumberKey = origin.sequenceNumberKey;
    }
    if (origin.totalNumberKey) {
      this.totalNumberKey = origin.totalNumberKey;
    }
    if (origin.maxTextLength) {
      this.maxTextLength = origin.maxTextLength;
    }
    if (origin.validInputs) {
      this.validInputs = origin.validInputs;
    }
    if (origin.min !== undefined) {
      this.min = origin.min;
    }
    if (origin.max !== undefined) {
      this.max = origin.max;
    }
    return this;
  }
}
